(function () {
  'use strict';

  var locked = new Map();

  function measureAndLock() {
    document.querySelectorAll('button.swatch--size').forEach(function (btn) {
      var key = btn.getAttribute('data-value');
      if (key && !locked.has(key)) {
        btn.style.minWidth  = '';
        btn.style.minHeight = '';
        var w = btn.offsetWidth;
        var h = btn.offsetHeight;
        if (w > 0 && h > 0) {
          locked.set(key, { w: w, h: h });
        }
      }
    });
    applyLocked();
  }

  function applyLocked() {
    document.querySelectorAll('button.swatch--size').forEach(function (btn) {
      var key = btn.getAttribute('data-value');
      if (key && locked.has(key)) {
        var size = locked.get(key);
        btn.style.minWidth   = size.w + 'px';
        btn.style.minHeight  = size.h + 'px';
        btn.style.boxSizing  = 'border-box';
        btn.style.whiteSpace = 'nowrap';
      }
    });
  }

  function init() {
    measureAndLock();

    var container = document.querySelector('ul.flex.flex-wrap') || document.body;

    var observer = new MutationObserver(function () {
      applyLocked();
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(function () {
    locked.clear();
    measureAndLock();
  }, 800);

})();